"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectPortalContext = void 0;
exports.useSelectPortalContext = useSelectPortalContext;
var _formatErrorMessage2 = _interopRequireDefault(require("@base-ui/utils/formatErrorMessage"));
var React = _interopRequireWildcard(require("react"));
const SelectPortalContext = exports.SelectPortalContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") SelectPortalContext.displayName = "SelectPortalContext";
function useSelectPortalContext() {
  const value = React.useContext(SelectPortalContext);
  if (value === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'Base UI: <Select.Portal> is missing.' : (0, _formatErrorMessage2.default)(58));
  }
  return value;
}